<template>
    <div id="storyBlockRoot">
        <div id="story-block-wrapper">
            <div v-if="topStories" id="top-story-bar-wrapper">
                <div class="topStoriesSectionTitleWrapper">
                    <span class="topStoriesSectionTitle topSectionTitle">{{
                        sectionTitle
                    }}</span>
                </div>
                <div class="topStoryWrapper">
                    <div
                        v-for="(story, index) in topStories"
                        :key="index"
                        :id="`${index}_top-story`"
                        class="topStory"
                    >
                        <a target="_blank" :href="story.link">
                            <div class="topStoryImgWrapper">
                                <img
                                    v-if="story.image && story.image.url"
                                    class="topStoryImg"
                                    :src="getImageUrl(story.image.url)"
                                />
                                <img
                                    v-else
                                    class="topStoryImg"
                                    :src="getPlaceholderImg(index)"
                                />
                            </div>
                            <div class="topStoryTitleWrapper">
                                <span
                                    class="topStorytitle"
                                    :title="getTitleText(story.title).full"
                                    >{{
                                        getTitleText(story.title).truncated
                                    }}</span
                                >
                            </div>
                            <div
                                v-if="story.source && story.source.title"
                                class="topStorySourceWrapper"
                            >
                                <span class="topStorySource sourceText">{{
                                    story.source.title
                                }}</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div
                v-if="bottomStories && doneLoading"
                id="bottom-story-block-wrapper"
            >
                <div class="bottomStoryWrapper">
                    <div
                        v-for="(story, index) in bottomStories"
                        :key="index"
                        :id="`${index}_bottom-story`"
                        class="bottomStory"
                    >
                        <a target="_blank" :href="story.link">
                            <div class="bottomStoryInnerWrapper">
                                <div class="bottomStoryImgWrapper">
                                    <img
                                        v-if="story.image && story.image.url"
                                        class="bottomStoryImg"
                                        :src="getImageUrl(story.image.url)"
                                    />
                                    <img
                                        v-else
                                        class="bottomStoryImg"
                                        :src="
                                            getPlaceholderImg(
                                                index + barStoryCount
                                            )
                                        "
                                    />
                                </div>
                                <div class="bottomStoryDataWrapper">
                                    <div class="bottomStorySectionTitleWrapper">
                                        <span
                                            class="bottomStorySectionTitle sectionTitle"
                                            >{{ sectionTitle }}</span
                                        >
                                        <span
                                            v-if="
                                                story.source &&
                                                    story.source.title
                                            "
                                            class="bottomStorySource sourceText"
                                            >-<span
                                                class="bottomStorySourceText"
                                                >{{ story.source.title }}</span
                                            ></span
                                        >
                                    </div>
                                    <div class="bottomStoryTitleWrapper">
                                        <span class="bottomStoryTitle">{{
                                            getTitleText(story.title).truncated
                                        }}</span>
                                    </div>
                                    <div
                                        v-if="
                                            story.description &&
                                                story.description != 'undefined'
                                        "
                                        class="bottomStoryDesc"
                                    >
                                        {{ getStoryDesc(story.description) }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { documentReady } from "@/common";

export default {
    name: "story-block",
    props: ["storyList", "barCount", "category", "fullStoryMode"],
    data() {
        return {
            stories: this.storyList || null,
            barStoryCount: this.barCount || 5,
            sectionTitle: this.category || null,
            currentPlaceholderIndex: 0,
            placeholderArray: [],
            maxPlaceholderCount: 7,
            doneLoading: false,
        };
    },
    mounted() {
        this.stories = this.storyList || null;
        this.barStoryCount = this.barCount || 5;
        this.sectionTitle = this.category || null;

        if (this.storyList.length < 7)
            this.maxPlaceholderCount = this.storyList.length;
        this.placeholderArray = this.shuffleArray([...Array(7).keys()]).slice(
            0,
            this.maxPlaceholderCount
        );

        documentReady.then(async () => {
            this.doneLoading = true;
        });
    },
    computed: {
        topStories() {
            if (this.fullStoryMode == true) return null;

            if (this.stories && this.stories.length > this.barStoryCount)
                return this.stories.slice(0, this.barStoryCount);
            if (this.stories) return this.stories;
            return null;
        },
        bottomStories() {
            if (this.stories && this.fullStoryMode == true) return this.stories;
            if (this.stories && this.stories.length > this.barStoryCount)
                return this.stories.slice(this.barStoryCount);
            return null;
        },
    },
    methods: {
        getImageUrl(oldUrl) {
            if (oldUrl.includes("yimg.com")) {
                const url = new URL(oldUrl);
                const hostParts = url.host.split(".");
                // hostParts[0] = "s";
                const newHost = hostParts.join(".");
                url.host = newHost;
                let newUrl = url.toString();
                newUrl = newUrl.replace("http://", "https://");
                return newUrl;
            }
            return oldUrl;
        },
        getStoryDesc(html) {
            const MAX_LENGTH = 325;

            const temporalDivElement = document.createElement("div");
            temporalDivElement.innerHTML = html;
            let returnText = this.decodeHTMLString(
                temporalDivElement.textContent ||
                    temporalDivElement.innerText ||
                    ""
            );
            returnText = returnText.replace(/&quot/g, '"');

            if (returnText.length > MAX_LENGTH - 3) {
                const returnString = `${returnText.substring(
                    0,
                    MAX_LENGTH
                )}...`;
                return returnString;
            }
            return returnText;
        },
        getTitleText(title) {
            const MAX_LENGTH = 150;

            let returnText = this.decodeHTMLString(title);
            returnText = returnText.replace(/&quot/g, '"');

            if (returnText.length > MAX_LENGTH - 3)
                return {
                    truncated: `${returnText.substring(0, MAX_LENGTH)}...`,
                    full: returnText,
                };
            return { truncated: returnText, full: returnText };
        },
        decodeHTMLString(str) {
            return str.replace(/&#(\d+);/g, (match, dec) =>
                String.fromCharCode(dec)
            );
        },
        shuffleArray(oldArray) {
            const array = oldArray;
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        getPlaceholderImg(index) {
            let cat = this.sectionTitle.toLowerCase();
            cat = cat.replace(/\s/g, "");
            if (this.fullStoryMode) index -= this.barStoryCount;

            if (index < this.maxPlaceholderCount && cat) {
                const path = `/assets/images/home/placeholders/${cat}_${this
                    .placeholderArray[index] + 1}.gif`;
                return path;
            }
            if (this.maxPlaceholderCount && cat) {
                let overflow = Math.floor(index / this.maxPlaceholderCount);
                if (overflow >= 0 && overflow < this.maxPlaceholderCount)
                    overflow = 1;
                let newIndex = index - this.maxPlaceholderCount * overflow;
                if (newIndex >= 0 && newIndex < this.maxPlaceholderCount)
                    newIndex = 0;
                const path = `/assets/images/home/placeholders/${cat}_${this
                    .placeholderArray[newIndex] + 1}.gif`;
                return path;
            }
            return null;
        },
    },
};
</script>

<style scoped>
#story-block-wrapper a {
    text-decoration: none;
    color: #3d3d3d;
    line-height: 135%;
    display: inline-block;
    width: 100%;
}

#story-block-wrapper a:hover .bottomStoryTitle {
    color: #25509f;
}

#story-block-wrapper {
    display: grid;
    grid-template-rows: auto auto;
}

#story-block-wrapper a:hover {
    background-color: #fafafa;
}

.sectionTitle {
    color: #0757e7;
    font-weight: 700;
    font-size: 0.75rem;
}

#top-story-bar-wrapper {
    display: block;
    grid-row-start: 1;
}

.topStoryWrapper {
    display: flex;
    font-size: 0.8rem;
}

.topStoryWrapper a {
    padding-bottom: 10px;
}

.topStoryWrapper a:hover .topStorytitle {
    color: #25509f;
}

.topStory {
    display: inline-block;
    padding-right: 10px;
    flex: 1;
}

.topStoryImgWrapper {
    width: 146.25px;
    height: 90px;
}

.topStoryImg {
    width: 100%;
    height: 100%;
    object-fit: fill;
}

.topStoryTitleWrapper {
    width: 130px;
    overflow: hidden;
    height: 50px;
    margin-top: 10px;
}

#bottom-story-block-wrapper {
    display: block;
    grid-row-start: 2;
}

.bottomStoryInnerWrapper {
    display: grid;
    grid-template-columns: auto 1fr;
    padding: 8px 0;
}

.bottomStoryImgWrapper {
    grid-column-start: 1;
    display: inline-block;
    padding-right: 15px;
}

.bottomStoryImg {
    width: 163px;
    height: 100px;
}

.bottomStoryDataWrapper {
    grid-column-start: 2;
    display: inline-block;
}

.bottomStory {
    margin: 10px 0px;
}

.bottomStoryTitle {
    margin-bottom: 5px;
    display: inline-block;
    color: #4480ec;
    font-size: 1.1rem;
}

.bottomStoryDesc,
.topStoryTitleWrapper {
    font-size: 0.9rem;
}

.bottomStorySource {
    padding-left: 5px;
    font-size: 0.75rem;
}

.bottomStorySourceText {
    padding-left: 5px;
}

.topStorySourceWrapper {
    padding-top: 5px;
}

.topStorySource {
    font-size: 0.5rem;
}

.topStorySource,
.bottomStorySource {
    color: #858585;
}
</style>
